<template>
  <div>
    <div class="level">
      <div class="level-item has-text-left">
        <span
          class="control is-size-4 is-uppercase simple-text"
          @click="$emit('close-preview')"
        >
          <font-awesome-icon
            icon="chevron-left"
            class="icon"
            style="padding-top: 3px;"
          />
          {{ $t('templatepicker.back.tag') }}
        </span>
      </div>
      <div
        class="level-item is-size-4 is-uppercase simple-text text-right"
        :class="singleSelected"
        @click="changeMode('onePage')"
      >
        {{ $t('templatepicker.single_page.tag') }}
      </div>

      <div
        class="level-item is-size-4 is-uppercase simple-text text-left"
        :class="multiSelected"
        @click="changeMode('multiPages')"
      >
        {{ $t('templatepicker.multi_page.tag') }}
      </div>

      <div class="level-item">
        <button
          v-if="pendingInfo"
          class="button is-primary is-large is-broad is-uppercase"
          :disabled="true"
        >
          {{ $t('templatepicker.pending_template.tag') }}
        </button>
        <button
          v-else
          class="button is-primary is-large is-broad is-uppercase"
          :disabled="disabled"
          :class="isLoading"
          @click="pickTemplate"
        >
          {{ $t('templatepicker.select_template.tag') }}
        </button>
      </div>
    </div>

    <transition>
      <div
        v-show="pendingInfo"
        class="level"
      >
        <div class="level-item has-text-centered">
          <!-- Pending info message -->
          <div
            class="notification is-info"
          >
            <font-awesome-icon
              icon="info-circle"
              class="is-medium has-text-white"
            />
            <p v-html="$t('templatepicker.pending_info.tag')" />
          </div>
        </div>
      </div>
    </transition>

    <transition>
      <div
        v-show="successSave"
        class="level"
      >
        <div class="level-item has-text-centered">
          <!-- Success message -->
          <div
            class="notification is-success"
          >
            <font-awesome-icon
              icon="check-circle"
              class="is-medium has-text-white"
            />
            {{ $t('common.info_edited_ok') }}
          </div>
        </div>
      </div>
    </transition>

    <transition>
      <div
        v-show="failedSave"
        class="level"
      >
        <div class="level-item has-text-centered">
          <!-- Error message -->
          <div class="notification is-danger">
            <font-awesome-icon
              icon="exclamation-triangle"
              class="is-medium has-text-white"
            />
            {{ $t('common.try_again') }}
          </div>
        </div>
      </div>
    </transition>

    <section
      v-show="!loading"
      class="section is-full"
    >
      <iframe
        :src="previewUrl"
        class="iframe_container"
        @load="toggleLoading"
        id="templatePreviewFrame"
        :key="iframeUpdate"
      />
    </section>
    <section
      v-show="loading"
      class="section is-full has-text-centered"
    >
      <font-awesome-icon
        icon="redo-alt"
        class="search-spinner fa-spin"
      />
    </section>
  </div>
</template>

<script>

import { SECONDS_IN_MS } from '@/helpers'
import templatePickerMixin from '../../mixins/template-picker'
import generatedSiteplusUrlMixin from '@/mixins/siteplus-generated-urls'

export default {

  name: 'TemplatePreview',
  mixins: [
    templatePickerMixin,
    generatedSiteplusUrlMixin
  ],
  props: {
    template: {
      type: Object,
      default () {}
    }
  },
  data () {
    return {
      multiSelected: '',
      singleSelected: 'chosen-option',
      previewUrl: '',
      selectedType: 'onePage',
      loading: true,
      selectedTemplateId: null,
      disabled: false,
      successSave: false,
      failedSave: false,
      pendingInfo: false,
      pendingButton: true,
      iframeUpdate:false
    }
  },

  computed: {
    isLoading () {
      if (this.disabled === true) {
        return 'is-loading'
      }
      return ''
    }
  },

  watch: {
    template () {
      this.changeUrl()
    },
    siteplusWebsiteDetails: {
      handler () {
        if (this.siteplusWebsiteDetails && this.siteplusWebsiteDetails.serviceState === 'Fulfilled') {
          this.pendingInfo = false
        } else {
          this.pendingInfo = true
        }
      }
    }
  },

  methods: {

    changeMode (mode) {
      if (mode === 'onePage') {
        this.selectedType = 'onePage'
        this.multiSelected = ''
        this.singleSelected = 'chosen-option'
      } else {
        this.selectedType = 'multiPages'
        this.multiSelected = 'chosen-option'
        this.singleSelected = ''
      }
      this.changeUrl()     
    },

    toggleLoading () {
      this.iframeUpdate = true
      this.loading = false
    },
  

    changeUrl () {
      this.previewUrl = ''
      this.loading = true
      if (this.template && typeof (this.template.versions) !== 'undefined') {
        let found = false
        let index = 0
        while (!found && index < this.template.versions.length) {
          if (this.template.versions[index].type === this.selectedType) {
              const url = this.template.versions[index].linkUrl
            this.selectedTemplateId = this.template.versions[index].id
            this.iframeUpdate =false
            if (url.indexOf('https://') < 0) {
                this.previewUrl = 'https://' + url
            } else {
              this.previewUrl = url
            }
            found = true
          }
          index++
        }
      }
    },

    async pickTemplate () {
      this.disabled = true
      this.successSave = false
      this.failedSave = false

      var result = await this.selectTemplate(this.selectedTemplateId, true)

      if (result !== false) {
        this.successSave = true
        setTimeout(() => {
          this.$router.push({ name: 'MainSection' })
        }, SECONDS_IN_MS(2))
      } else {
        this.failedSave = true
        this.disabled = false
        setTimeout(() => {
          this.successSave = false
          this.failedSave = false
        }, SECONDS_IN_MS(2))
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

  .v-enter-active, .v-leave-active {
    transition: opacity .5s
  }

  .v-enter, .v-leave-to {
    opacity: 0
  }

  .search-spinner {
    font-size: 136px;
    color: var(--primary-color);
    margin-top: 30px;
  }

  .iframe_container {
    width: 100%;
    height: 100vh;
  }

  .simple-text {
    color: #878f95;
    cursor: pointer;
  }

  .simple-text:hover {
    color: var(--primary-color);
  }

  .chosen-option {
    color: var(--primary-color);
  }

  .text-left {
    padding-left:0px;
    justify-content: center;
  }

  .text-right {
    justify-content: center;
    padding-right: 0px;
  }

  .icon {
    margin-right: 5px;
    margin-bottom: 2px;
  }

  @media (min-width:1020px) {

    .text-left {
      padding-left:6px;
      justify-content: flex-start;

    }

    .text-right {
      justify-content: flex-end;
      padding-right:6px;
    }
  }
</style>
